import type { AutomationRule, AutomationSettings, BrandSettings, ReferralSettings, StoredValueSettings } from '@lp/shared';

const rule = (title: string, body: string): AutomationRule => ({ enabled: false, email: false, title: { 'zh-Hant': title }, body: { 'zh-Hant': body }, rewardId: null, points: 0 });

/** Starting text of each reminder until the brand saves its own. */
export const DEFAULT_AUTOMATIONS: AutomationSettings = {
  pointsExpiry: { ...rule('你的積分即將到期', '{name}，你的 {points} 分將於 {date} 到期，記得在到期前使用。'), daysBefore: [30, 7] },
  inactive: { ...rule('好久不見', '{name}，我們很掛念你！歡迎回來，你現有 {points} 分。'), days: 90 },
  tierUpgrade: rule('恭喜升級', '{name}，恭喜你升級至 {level}！'),
  tierExpiry: { ...rule('你的會員等級即將到期', '{name}，你的 {level} 等級將於 {date} 到期。'), daysBefore: 30 },
  couponExpiry: { ...rule('你的優惠券即將到期', '{name}，你的「{coupon}」將於 {date} 到期，請盡快使用。'), daysBefore: 7 },
};

export const DEFAULT_REFERRAL: ReferralSettings = {
  enabled: false,
  trigger: 'first_purchase',
  referrer: { points: 0, rewardId: null },
  referee: { points: 0, rewardId: null },
  monthlyCap: null,
  terms: {},
};

export const DEFAULT_STORED_VALUE: StoredValueSettings = { bonusRules: [], minTopup: 0, maxBalance: null, validDays: null, skus: [], terms: {} };

/** Fills sections an older API response may not have yet, so pages can rely on them. */
export function withDefaults(s: BrandSettings): BrandSettings {
  return {
    ...s,
    registration: { ...s.registration, phoneLogin: s.registration?.phoneLogin ?? false, googleLogin: s.registration?.googleLogin ?? true },
    automations: s.automations ?? DEFAULT_AUTOMATIONS,
    referral: s.referral ?? DEFAULT_REFERRAL,
    storedValue: s.storedValue ?? DEFAULT_STORED_VALUE,
  };
}
